import EmrFormItem from '@/screens/CreateEmr/EmrInput/EmrFormItem';
import { IEmrInputProps } from '@/screens/CreateEmr/EmrInput/EmrInput';
import * as React from 'react';
import { Checkbox, Flex } from 'antd';
import { CheckboxProps } from 'antd/lib';
import { CheckboxChangeEvent } from 'antd/es/checkbox';

export interface IEmrCheckboxProps
  extends Pick<IEmrInputProps, 'name' | 'field' | 'labelProps'>,
    Omit<CheckboxProps, 'name'> {}

const EmrCheckbox: React.FC<IEmrCheckboxProps> = ({ field, name, labelProps = {}, ...props }) => {
  return (
    <EmrFormItem field={field} name={name} {...labelProps} label={''} getValueFromEvent={(v) => v?.target?.checked}>
      <CustomCheckbox title={field?.label} {...props} />
    </EmrFormItem>
  );
};

export default EmrCheckbox;

const CustomCheckbox = ({
  value,
  title = '',
  ...props
}: {
  value?: any;
  id?: string;
  onChange?: ((e: CheckboxChangeEvent) => void) | undefined;
  title?: React.ReactNode;
}) => {
  return (
    <Flex gap={4}>
      <Checkbox
        className="[&_.ant-checkbox-disabled:not(.ant-checkbox-checked)_.ant-checkbox-inner]:bg-transparent"
        defaultChecked={value === true}
        {...props}
      />
      <span>{title}</span>
    </Flex>
  );
};
